import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    codigo: '',
    marcaModelo: '',
    numeroSerie: '',
    caracteristicas: '',
    rubroId: 0,
    rubro: null,
    rubroNombre: null,
    cotizacion: 0,
    pjeAmortizacion: 0,
    enRevision: false,
    rowVersion: null,
};

const mutations = {
    updateField,

    'INICIALIZAR_COMPUTADORA'(state, computadoraId) {
        state.id = computadoraId;
        state.codigo = '';
        state.marcaModelo = '';
        state.numeroSerie = '';
        state.caracteristicas = '';
        state.rubroId = 0;
        state.rubro = null;
        state.rubroNombre = null;
        state.cotizacion = 0;
        state.pjeAmortizacion = 0;
        state.enRevision = false;
        state.rowVersion = null;
    },
    'SET_COMPUTADORA'(state, computadora) {
        state.codigo = computadora.codigo.toUpperCase().trim();
        state.marcaModelo = computadora.marcaModelo.toUpperCase().trim();
        state.numeroSerie = computadora.numeroSerie.trim();
        state.caracteristicas = computadora.caracteristicas.trim();
        state.rubroId = computadora.rubroId;
        state.rubro = computadora.rubro;
        state.rubroNombre = computadora.rubro? computadora.rubro.nombre.trim() : null;
        state.cotizacion = parseFloat(computadora.cotizacion);
        state.pjeAmortizacion = parseFloat(computadora.pjeAmortizacion);
        state.enRevision = (/true/i).test(computadora.enRevision);
        state.rowVersion = computadora.rowVersion;
    },
    'SET_RUBRO'(state, rubro) {
        state.rubro = rubro;
        if (rubro) {
            state.rubroId = rubro.id? rubro.id : 0;
            state.rubroNombre = rubro.nombre? rubro.nombre.trim() : null;
        } else {
            state.rubroId = 0;
            state.rubroNombre = null;
        }
    },
    'SET_COMPUTADORA_ID' (state, params) {
        state.id = params.id;
        state.rowVersion = params.rowVersion;
    },
};

const getters = {
    getField,

    computadora(state) {
        return {
            id: state.id,
            codigo: state.codigo.toUpperCase().trim(),
            marcaModelo: state.marcaModelo.toUpperCase().trim(),
            numeroSerie: state.numeroSerie.trim(),
            caracteristicas: state.caracteristicas.trim(),
            rubroId: state.rubroId,
            enRevision: (/true/i).test(state.enRevision),
            rowVersion: state.rowVersion,
        }
    }
};

const actions = {
    inicializar ( { commit }, computadoraId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_COMPUTADORA', computadoraId);
            
            if (computadoraId != 0){
                apiAxios.get(`bienes/computadoras/${computadoraId}/abm` ) 
                    .then(res => {
                        commit('SET_COMPUTADORA', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },    
    save ( {commit} ) {
        return new Promise((resolve, reject) => {
            let computadora= {
                codigo: state.codigo.toUpperCase().trim(),
                marcaModelo: state.marcaModelo.toUpperCase().trim(),
                numeroSerie: state.numeroSerie.trim(),
                caracteristicas: state.caracteristicas.trim(),
                rubroId: parseInt(state.rubroId),
                cotizacion: parseFloat(state.cotizacion),
                pjeAmortizacion: parseFloat(state.pjeAmortizacion),
                enRevision: state.enRevision,
            }
            let url = 'bienes/computadoras';
            
            if (state.id != 0) {
                url += '/' + state.id;
                computadora.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, computadora)
                .then((res) => {
                    /* Actualizamos Id y RowVersion */
                    commit('SET_COMPUTADORA_ID', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setRubro: ({commit}, rubro) => {
        commit('SET_RUBRO', rubro);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}